import { useSettings } from '@wu/widget-core';
import { getTemperatureUnit } from './get-temperature-unit';

export const useTemperature = ({ temp = 0 }) => {
  const { showUnits, language } = useSettings();
  const { language: locale } = language ?? {};
  const units = getTemperatureUnit(locale);

  const unitsIcon = (() => {
    if (!showUnits) {
      return '';
    }

    return units === 'metric' ? 'C' : 'F';
  })();

  const derivedTemp = units === 'imperial' ? temp : ((temp - 32) * 5) / 9;
  const roundedTemp = derivedTemp.toFixed(0);
  const formattedTemp = roundedTemp === '-0' ? 0 : roundedTemp;

  return { processedTemperature: `${formattedTemp}°${unitsIcon}` };
};
